import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useTicketsMutations } from '../../hooks';
import { getUsuariosSucursal } from '../../services/UsuarioSucursal';
import { uploadFile , downloadFile } from '../../services/filesTools';
import { FooterPages } from '..';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';

const initialState = {
empresa:'',
tipo: 'Taller',
numTicket: '',
requerimiento: '',
observacion: '',
documentosRespaldo:[],
fechaEntrega: null,
numOT: '',
fechaCreacion: new Date(),
idCreador: null,
idAsignado: null,
estado: 'Pendiente',
};

const NuevoTicketsLF = ({vecinoData, onChangeVecino}) => {
  const { isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [usuarioData, setUsuarioData] = useState([]);
  // Reemplaza el antiguo pdfFiles con documentosRespaldo
  const [documentosRespaldo, setDocumentosRespaldo] = useState([]);
  const { addTicket, updateTicketC } = useTicketsMutations();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const userInfo = fetchUser();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  useEffect(() => {
    if(vecinoData) {
      setFormData(vecinoData);
      setSelectedDate(vecinoData.fechaEntrega !== null ? new Date(vecinoData.fechaEntrega) : getFirstDayOfMonth('Nada'));  
    }
    if (vecinoData && vecinoData.documentosRespaldo) {
      setDocumentosRespaldo(vecinoData.documentosRespaldo);
    }
  }, [vecinoData]);

useEffect( () => {
  const fetchData = async () => { 
    const misUsuario = await getUsuariosSucursal();
    setUsuarioData(misUsuario);
  };
  fetchData();
},[]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateObraChange = (date) => {
    setSelectedDate(date);
  };

// Subida de archivo
const handleFileChange = async (e) => {
  const selectedFile = e.target.files[0];
  if (!selectedFile) return;

  const response = await uploadFile(selectedFile);
  if (response && response.fileId) {
    const nuevoArchivo = {
      nombreArchivo: selectedFile.name,
      idArchivo: response.fileId
    };
    setDocumentosRespaldo((prev) => [...prev, nuevoArchivo]);
  } else {
    toast.error('Error al subir el archivo.');
    console.error('Error de carga:');
  }
};

// Descargar archivo
const handleDownload = async (idArchivo, nombreArchivo) => {
  try {
    const blob = await downloadFile(idArchivo); // debe retornar Blob o File
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error al descargar archivo:', error);
    toast.error('Error al descargar el archivo');
  }
};

// Eliminar archivo
const handleRemoveFile = (idArchivo) => {
  const filtrados = documentosRespaldo.filter((doc) => doc.idArchivo !== idArchivo);
  setDocumentosRespaldo(filtrados);
};

  const handleSubmit = async (e) =>{
    e.preventDefault();

    if( vecinoData.estado === 'Finalizado') 
      {
        toast.error('El ticket se encuentra en un estado que no se puede modificar');
        return;
      }


    if(selectedDate === null || selectedDate === '') 
      {
        toast.error('Debe Ingresar la fecha de Entrega');
        return;
      }

    if(!vecinoData._id) 
    {
      const dataBase = {
        empresa: userInfo.empresa,
        tipo: formData.tipo,
        numTicket: 0, // Número secuencial
        requerimiento: formData.requerimiento,
        observacion: formData.observacion,
        documentosRespaldo: documentosRespaldo,
        fechaEntrega: selectedDate.toISOString(),
        numOT: formData.numOT,
        fechaCreacion: new Date().toISOString(),
        idCreador: userInfo.usuario,
        idAsignado: null,
        estado: formData.estado
      };
      // console.log('crear VECINO');
       await addTicket.mutateAsync( dataBase );
    } else
    { 
      const dataBase = {
        _id: vecinoData._id,
        empresa: userInfo.empresa,
        tipo: formData.tipo,
        requerimiento: formData.requerimiento,
        observacion: formData.observacion,
        documentosRespaldo: documentosRespaldo,
        fechaEntrega: selectedDate.toISOString(),
        numOT: formData.numOT, 
        fechaCreacion: new Date().toISOString(),
        idCreador: formData.idCreador,
        idAsignado: formData.idAsignado,
        estado: formData.estado
      };
       await updateTicketC.mutateAsync( dataBase );

      if (formData.numOT !== '' && formData.estado==='Finalizado'){


      }

    };

    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevoTicket );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-3/4 p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nuevo" : "Editar"} Ticket
              </p>
            </div>
            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoTicket)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          
          <div className="mt-5 space-y-4">

            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-2 md:grid-cols-7 gap-4" >
                  <div className="col-span-2">
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Fecha Entrega*</label>
                      <SeleccionaFecha
                        selectedDate={selectedDate}
                        handleDateChange={handleDateObraChange}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col ">
                    <label className="text-xs font-semibold mb-1">N° OT</label>
                    <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="numOT"
                        value= {formData.numOT}
                        onChange={handleChange}
                    />
                  </div>
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Estado*</label>
                        <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                            <option value="Pendiente">Pendiente</option>
                            <option value="Cancelado">Cancelado</option>
                            <option value="Finalizado">Finalizado</option>
                        </select>
                    </div>

                    <div className="flex flex-col ">
                        <label className="text-xs font-semibold mb-1">N° TIcket</label>
                        <input
                            type="text"
                            className={inputClass}
                            placeholder=""
                            name="numTicket"
                            value= {formData.numTicket}
                            disabled
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-span-2">
                      <div className="flex flex-col ">
                            <label className="text-xs font-semibold mb-1">Creado por</label>
                            <select className={inputClass} disabled name="idCreador"
                                value={formData.idCreador} onChange={handleChange}>
                              <option value=""></option>
                              {usuarioData?.map((item, index) => (
                                <option  key={item._id} value={item._id}>{item.nombre}</option>
                              ))}  
                            </select>
            
                        </div>
                    </div>

                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-5" >
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Requerimiento</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="requerimiento"
                        value= {formData.requerimiento}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-5" >
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Observación</label>
                      <textarea
                        className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300 h-48 max-h-96"
                        type="text"
                        placeholder=""
                        name="observacion"
                        value= {formData.observacion}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-5">
  <div className="col-span-2">
    <div className="flex flex-col">
      <label className="text-xs font-semibold mb-1">Adjuntar archivo</label>
      <input type="file" accept=".pdf" onChange={handleFileChange} />
    </div>
  </div>

  <div className="col-span-5 mt-4">
    <label className="text-xs font-semibold mb-1">Archivos Subidos</label>
    {documentosRespaldo.length === 0 ? (
      <p className="text-xs text-gray-500">No hay archivos cargados.</p>
    ) : (
      <ul className="text-sm space-y-2 mt-1">
        {documentosRespaldo.map((doc, index) => (
          <li key={index} className="flex items-center justify-between bg-gray-100 rounded px-3 py-1">
            <span className="truncate">{doc.nombreArchivo}</span>
            <div className="flex space-x-2">
              <button
                type="button"
                onClick={() => handleDownload(doc.idArchivo, doc.nombreArchivo)}
                className="text-blue-600 hover:underline text-xs"
              >
                Descargar
              </button>
              <button
                type="button"
                onClick={() => handleRemoveFile(doc.idArchivo)}
                className="text-red-500 hover:underline text-xs"
              >
                Eliminar
              </button>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
</div>

                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-5" >
                  <div className="col-span-2">
                      <div className="flex flex-col ">
                        <label className="text-xs font-semibold mb-1">Asignado a</label>
                        <select className={inputClass} disabled name="idAsignado"
                            value={formData.idAsignado} onChange={handleChange}>
                          <option value=""></option>
                          {usuarioData?.map((item, index) => (
                            <option  key={item._id} value={item._id}>{item.nombre}</option>
                          ))}  
                        </select>
                      </div>
                  </div>

                </div>
              </div>
                    <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                        <button
                            onClick={handleSubmit}
                            className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                        >
                         {!vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                        </button>
                    </div>
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} /> 
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoTicketsLF;